import React, {Component} from 'react';
import {subscribe} from '../../utils/bunifu-redux';
import {Button, Drawer, Checkbox, Tag, Divider, Mention, Card, message } from 'antd';  
import Axios from 'axios';
class Message extends Component {
state = {
   name: 'Message',
   message: "", 
   sms: true,
   app: true,
   email: false,
   loading: false
}
componentWillMount() {
  subscribe(this);
}

getRecipients() {
    return Array.isArray(this.props.data) ? this.props.data : [];
}

normalizePhone(phone) {
    return phone === undefined || phone === null ? "" : phone.toString().trim();
}

buildSmsMessages() {
    if (!this.state.sms) {
        message.error("Select SMS to send messages from this composer.");
        return null;
    }

    var messages = [];

    this.getRecipients().forEach(curMessage=> {
        var phone = this.normalizePhone(curMessage.Phone);

        if (!phone) {
            return;
        }

        var msg=this.state.message;
        Object.keys(curMessage).forEach(e => {
            msg = msg.split("@"+e).join(curMessage[e]);
        });

        messages.push({
            Phone: phone,
            Email: curMessage.Email,
            Message: msg,
            sendEmail: false,
            sendAppNotification: false,
            sendSMS: true,
        });
    });

    return messages;
}

getTags() {
    const recipients = this.getRecipients();

    if(recipients.length>0) {
        var arr = [];
        Object.keys(recipients[0]).forEach(e => {
            if(!(e.length>2 && e.toLowerCase().endsWith("id")) &&  !(e.toLowerCase().endsWith("_at")) && typeof recipients[0][e] === 'string'  && (!Array.isArray(recipients[0][e]))) {
               arr.push(e);
            }
        });

        return arr;
    }
   return [];
}
 
 render() {
 const recipients = this.getRecipients();
 const smsRecipientCount = recipients.filter((recipient) => this.normalizePhone(recipient.Phone)).length;

 return (
    <Drawer
        visible={this.props.visible}
        width={800}
        title={"Send Message"}
        onClose={this.props.onClose}
    >
      <Card loading={this.state.loading} bordered={false}>
      <Checkbox checked={this.state.sms} onChange={(val)=>this.setState({sms: val.target.checked})}>SMS</Checkbox> 
      <Checkbox checked={this.state.app} onChange={(val)=>this.setState({app: val.target.checked})}>Mobile App</Checkbox> 
      {/* <Checkbox checked={this.state.email} onChange={(val)=>this.setState({email: val.target.checked})}>Email</Checkbox>  */}
       <Divider/>
       <p>Recipients <Tag color="cyan">{smsRecipientCount}</Tag>
           {smsRecipientCount < recipients.length && <Tag color="orange">{recipients.length - smsRecipientCount} missing phone</Tag>}
       </p>
       <Divider/>
        <p>Compose Message</p>
       <Mention  defaultSuggestions={this.getTags()} multiLines={true} style={{color: Math.ceil(this.state.message.length/160) >6 ? "red" : "black"}} onChange={(val)=>this.setState({message: Mention.toString(val)})} />
          {this.state.sms &&  <h6 style={{color: '#3F4044',float: "right",marginRight: 5}}>Characters: {this.state.message.length} Pages: {Math.ceil(this.state.message.length/160)} of 6</h6>}
        <br/> <br/>
         { ((this.state.sms || this.state.app || this.state.email) && this.state.message.trim().length>0)
          &&  <Button onClick={()=>{
             var messages = this.buildSmsMessages();

             if (messages === null) {
                 return;
             }

             if (messages.length === 0) {
                 message.error("No recipients have a valid phone number.");
                 return;
             }

             this.setState({loading: true});
              
             Axios.post('/sms/send',messages)
                        .then(function (response) {
                             this.setState({
                                 loading: false,
                                 messages: []
                             });
                             this.props.onClose();
                             message.success("Delivered");
                        }.bind(this))
                        .catch(function (error) {
                            this.setState({loading: false});
                           message.error(error?.response?.data?.message || error.message);
                        }.bind(this));
             
         }} shape="round" type="primary">Send Message</Button>}
      </Card>
    </Drawer>
)
} 
}
export default Message;
